module.exports = __webpack_public_path__ + "media/images/icon-mask-magnifier-b987ce65e7e3db40acba2720ed76e04b.png";